/**
 * action type constants related to fetching the CAL Reports
 */
export const FETCH_CAL_REPORT_INFO_REQUEST = "FETCH_CAL_REPORT_INFO_REQUEST";
export const FETCH_CAL_REPORT_DATA_SUCCESS = "FETCH_CAL_REPORT_DATA_SUCCESS";
export const FETCH_CAl_REPORT_DATA_FAILURE = "FETCH_CAl_REPORT_DATA_FAILURE";

